import "./App.css";
import { Fade } from "react-awesome-reveal";

import {
  Banner,
  BannerText,
  ImageShowcase,
  DividerImage,
  BioSection,
  BioTitle,
  BioPerson,
  BioInfo,
  Footer,
  ImageContainer,
  BioImageContainer,
} from "./styles";
import img1 from "./images/1.jpg";
import img2 from "./images/2.jpg";
import img3 from "./images/3.jpg";
import wBio from "./images/winnie.jpeg";
import dBio from "./images/daniel.jpeg";
// import PhotoGrid from "./PhotoGrid";
import { Newnav } from "./Newnav";
import { ContactUs } from "./Contact";

const App = () => {
  return (
    <div className="App">
      <head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"
          rel="stylesheet"
        />
      </head>
      <Newnav />
      <Banner>
        <Fade cascade damping={0.1}>
          <BannerText>
            <p>CREATING MEMORABLE</p>
            <p>MOMENTS TOGETHER</p>
          </BannerText>
        </Fade>
      </Banner>
      <ImageShowcase>
        <ImageContainer>
          <img src={img1} alt="img1" />
        </ImageContainer>
        <ImageContainer>
          <img src={img2} alt="img2" />
        </ImageContainer>
        <ImageContainer>
          <img src={img3} alt="img3" />
        </ImageContainer>
      </ImageShowcase>
      <DividerImage />
      <BioTitle>Meet the Team.</BioTitle>
      <BioSection>
        <BioPerson>
          <BioImageContainer>
            <img src={dBio} alt="person 1"></img>
          </BioImageContainer>
          <BioInfo>
            <p>
              Meet <strong>Daniel</strong>, your dude behind the lens at Double
              Knot Collective. Daniel’s friendly approach and eye for detail
              will make every client feel at ease, resulting in stunning,
              authentic photos. Based in Metro Vancouver, he loves to explore
              and find the perfect backdrop for each shot. Daniel’s knack for
              making people feel comfortable in front of the camera results in
              heartfelt and candid photos that reflect genuine emotions.{" "}
            </p>
            <p>
              When Daniel isn’t behind the camera, you will find him exploring
              new locations, actively engaging in sports, or enjoying time with
              family. For a photography experience that’s as enjoyable as it is
              professional, choose Double Knot Collective. Let’s have some fun
              and create beautiful memories together.
            </p>
          </BioInfo>
        </BioPerson>
        <BioPerson $reverse>
          <BioImageContainer>
            <img src={wBio} alt="person 2"></img>
          </BioImageContainer>
          <BioInfo $reverse>
            <p>
              <strong>Winnie</strong>, born and raised in Vancouver, BC, has
              been a photography enthusiast from a young age, always captivated
              by the art of capturing moments. Her lens is drawn to the beauty
              of nature, expressions in portraits, and the sleek lines of cars.
              Despite her full-time job as a licensed optician, Winnie’s heart
              belongs to photography, a passion that fuels her creative spirit.
            </p>
            <p>
              Beyond her love for photography, she is a car enthusiast, finding
              joy in their blend of form and function. Her love for pets and
              travel adds a layer of warmth and adventure to her personality,
              making her a delightful companion on any journey. Winnie’s
              friendly nature and love for meeting new people make her a natural
              at forming meaningful connections wherever she goes.
            </p>
          </BioInfo>
        </BioPerson>
        {/* ig */}
        {/* <Insta /> */}
      </BioSection>
      {/* <PhotoGrid media={media} /> */}
      <ContactUs nav={false} />
      <Footer></Footer>
    </div>
  );
};

export default App;
